export default __webpack_public_path__ + "static/popular-c-2-09bb9741cdf71fe39cf47488ea00f985.png";